var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 58,
    viewBox: "0 0 73 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73 44.653c-2.318.557-4.878.86-7.696.86h-.608c-18.435 0-25.826-12.98-26.609-25.117a20.683 20.683 0 01-.087-1.64c.022-.27.033-.542.044-.82.01-.265.022-.536.043-.818.391-6.072 2.437-12.355 6.691-17.118H68a5 5 0 015 5v39.653z",
    fill: "#9ABFE0",
    fillOpacity: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#packs)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.476 21.653c.687 0 1.243-.558 1.243-1.246 0-.689-.556-1.247-1.243-1.247-.686 0-1.242.558-1.242 1.247 0 .688.556 1.246 1.242 1.246z",
    fill: "#9ABFE0",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.353 20.882a.129.129 0 01-.077-.026l-.002-.001-.292-.224a.132.132 0 01-.047-.137.13.13 0 01.16-.092.129.129 0 01.045.022l.19.146.446-.585a.132.132 0 01.086-.05.13.13 0 01.096.026l-.003.004.003-.004a.13.13 0 01.024.182l-.526.688a.13.13 0 01-.103.05z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.476 25.296c.687 0 1.243-.558 1.243-1.247 0-.688-.556-1.246-1.243-1.246-.686 0-1.242.558-1.242 1.246 0 .689.556 1.247 1.242 1.247z",
    fill: "#9ABFE0",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.353 24.525a.13.13 0 01-.077-.026l-.002-.001-.292-.224a.13.13 0 01.158-.207l.19.146.446-.585a.129.129 0 01.137-.047.131.131 0 01.045.023l-.003.004.003-.004a.13.13 0 01.024.182l-.526.688a.132.132 0 01-.103.05z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.145 29.514c.686 0 1.243-.558 1.243-1.246 0-.689-.556-1.247-1.243-1.247-.686 0-1.242.558-1.242 1.247 0 .688.556 1.246 1.242 1.246z",
    fill: "#9ABFE0",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.022 28.743a.128.128 0 01-.077-.026h-.002l-.292-.225a.13.13 0 01.014-.216.13.13 0 01.144.01l.19.145.446-.585a.131.131 0 01.086-.05.128.128 0 01.096.026l-.003.004.003-.004a.13.13 0 01.024.183l-.526.687a.13.13 0 01-.103.051z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.608 2.137c.12-.1.273-.137.43-.137H61.83c.862 0 1.492.823 1.282 1.66-.625 2.49-1.712 7.296-1.812 10.94-.193 7.082 2.362 13.95 2.25 18a97.23 97.23 0 00-.028 2.593c0 1.79-1.44 3.257-3.23 3.257H38.55c-.972 0-1.667-.97-1.407-1.907.524-1.892 1.208-4.942 1.208-7.993 0-5.4-1.8-11.191-1.8-18.45 0-5.715 1.514-7.504 2.058-7.963z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.126 38.673H59.56v-.229h1.548c.036.002.767.023 1.441-.798 1.004-1.222 1.829-4.248.055-11.72-2.386-10.05-.396-18.927.57-22.278a1.116 1.116 0 00-.572-1.303 1.106 1.106 0 00-.495-.117H39.07a1.111 1.111 0 00-.898.459c-.41.564-.971 1.65-1.322 3.61l-.224-.04c.359-2.004.939-3.12 1.362-3.704A1.343 1.343 0 0139.07 2h23.037a1.333 1.333 0 011.316 1.097 1.36 1.36 0 01-.03.615c-.962 3.333-2.94 12.164-.568 22.16 1.799 7.579.934 10.67-.108 11.929-.687.83-1.445.872-1.59.872z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.558 6.187c.12-.1.273-.137.43-.137H58.23c.862 0 1.492.823 1.282 1.66-.626 2.491-1.714 7.297-1.813 10.94-.193 7.082 1.8 18 1.8 18v2.85a3 3 0 01-3 3h-21.55c-.972 0-1.667-.97-1.407-1.907.524-1.892 1.208-4.942 1.208-7.993 0-5.4-2.25-11.191-2.25-18.45 0-5.715 1.514-7.504 2.058-7.963z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.975 42.836H55.41v-.228h1.548c.036.001.767.022 1.441-.798 1.004-1.222 1.829-4.248.055-11.721-2.386-10.05-.396-18.927.57-22.277a1.116 1.116 0 00-.572-1.304 1.106 1.106 0 00-.495-.116H34.919a1.111 1.111 0 00-.898.458c-.41.565-.971 1.65-1.322 3.611l-.224-.04c.359-2.004.938-3.12 1.362-3.705a1.343 1.343 0 011.082-.553h23.037a1.333 1.333 0 011.316 1.098c.037.204.027.415-.03.614-.962 3.333-2.94 12.165-.568 22.161 1.799 7.578.934 10.67-.108 11.928-.688.83-1.445.872-1.59.872z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.058 10.687c.12-.1.273-.137.43-.137H53.73c.862 0 1.492.823 1.282 1.66-.626 2.491-1.714 7.296-1.813 10.94-.193 7.082 2.362 13.95 2.25 18a81.26 81.26 0 00-.026 1.778C55.412 45.165 53.615 47 51.378 47h-20.93c-.97 0-1.666-.97-1.406-1.907.524-1.892 1.208-4.943 1.208-7.993 0-5.4-2.25-11.192-2.25-18.45 0-5.715 1.514-7.504 2.058-7.963z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.523 34.2c-2.373-9.996-.394-18.829.568-22.16a1.344 1.344 0 00-.688-1.572 1.335 1.335 0 00-.597-.141H30.768a1.337 1.337 0 00-1.082.552c-.93 1.283-2.86 5.537-.704 17.306 1.152 6.297 1.135 10.59.759 13.418-.212 1.592-.537 2.72-.833 3.48l-.031.08a1.33 1.33 0 00.64 1.692 1.302 1.302 0 00.602.144h22.682l.024.001c.145 0 .903-.042 1.59-.872 1.042-1.26 1.907-4.35.108-11.928zm-.276 11.773c-.674.82-1.405.8-1.44.799H30.119a1.109 1.109 0 01-.92-.49 1.091 1.091 0 01-.112-1.034c.337-.87.587-1.771.747-2.69.538-2.948.639-7.497-.628-14.414-2.14-11.682-.248-15.872.664-17.13a1.117 1.117 0 01.898-.459h23.038a1.105 1.105 0 01.886.443 1.113 1.113 0 01.18.977c-.966 3.35-2.955 12.229-.57 22.277 1.774 7.473.95 10.499-.055 11.721z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.579 21.212h-11.87a.908.908 0 01-.909-.913.914.914 0 01.91-.912h11.869a.909.909 0 01.91.912.914.914 0 01-.91.913zm0 3.93h-11.87a.908.908 0 01-.909-.912.914.914 0 01.91-.913h11.869a.909.909 0 01.91.913.914.914 0 01-.91.912zm.955 4.027H32.665a.908.908 0 01-.91-.913.914.914 0 01.91-.912h11.87a.908.908 0 01.91.912.914.914 0 01-.91.913z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.204 33.387h-11.87a.908.908 0 01-.91-.913.914.914 0 01.91-.912h11.87a.908.908 0 01.91.912.914.914 0 01-.91.913zm.005-19.261h-8.53a.908.908 0 01-.91-.912.914.914 0 01.91-.913h8.53a.908.908 0 01.91.913.914.914 0 01-.91.912zM49.91 33.72c.686 0 1.242-.557 1.242-1.246 0-.688-.556-1.246-1.242-1.246-.686 0-1.242.558-1.242 1.246 0 .689.556 1.247 1.242 1.247zm-4.133 3.79H33.908a.909.909 0 01-.91-.913.914.914 0 01.91-.913h11.87a.908.908 0 01.909.913.914.914 0 01-.91.912zm4.706.333c.687 0 1.243-.558 1.243-1.246 0-.689-.556-1.247-1.243-1.247-.686 0-1.242.558-1.242 1.247 0 .688.556 1.246 1.242 1.246z",
    fill: "#9ABFE0",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "packs",
    x: 22,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPack);
export default __webpack_public_path__ + "static/media/pack.d615c095638f3dc9016c5beb8b70f8ad.svg";
export { ForwardRef as ReactComponent };